const OPEN_POPUP = "OPEN_POPUP";
const CLOSE_POPUP = "CLOSE_POPUP";

// Define reducer function
const trainAIPopupReducer = (state = { show: false }, action) => {
  switch (action.type) {
    case OPEN_POPUP:
      return {
        show: true,
      };
    case CLOSE_POPUP:
      return {
        show: false,
      };
    default:
      return state;
  }
};

const openPopup = () => ({
  type: OPEN_POPUP,
});

const closePopup = () => ({
  type: CLOSE_POPUP,
});

export { openPopup, closePopup };
export default trainAIPopupReducer;
